import styled from "@emotion/styled"
import { ShadowContainer } from "../../../../../styled/layout.styled"

export const OrderSortOptionsContainer = styled(ShadowContainer)({
  padding: "10px",
  overflow: "hidden",
})
